import React from "react";
// import { Modal, } from 'semantic-ui-react';
import Modal from "../modalGr/Modal";
const Confirm = ({ open, onConfirm, onCancel }) => {
  return (
    <Modal
      isOpen={open}
      hasCloseBtn={false}
      // onClose={handleEditModalClose}
      className={"modal-review"}
    >
      <div className="border" style={{ padding: "20px" }}>
        <div>
          {" "}
          <h6>Do You Want To Delete ?</h6>
        </div>
        <div className="flex-center">
          <span
            className="btntask"
            style={{ background: "#cc3333" }}
            onClick={onConfirm}
          >
            Delete
          </span>
          <span className="btntask" onClick={onCancel}>
            Cancel
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default Confirm;
